//Keys for user permissions object
export enum CATEGORIES {
  ADMIN_PORTAL = 'adminPortal',
  USER_PERMISSIONS = 'userPermissions',
  SEARCHES_MANAGER = 'searchManager',
  SEARCHES_MANAGER_DIAGNOSTICS = 'searchManagerDiagnostics',
  BOOKING_CREATE_MANAGER_OSIS = 'bookingCreateManagerOsis',
  BOOKING_CREATE_MANAGER_REMARKS = 'bookingCreateManagerRemarks',
  BOOKING_CREATE_MANAGER_SSR = 'ssrRules',
  REGIONS = 'regions',
  COUNTRIES = 'countries',
  CITIES = 'cities',
  AIRPORTS = 'airports',
  GEO_GROUPS = 'supplierLocationMappings',
  AIRLINES = 'airlines',
  AGENCIES = 'agencies',
  AGENCIES_GROUPS = 'agencyGroups',
  PROVIDER_CREDENTIALS = 'providerCredentials',
  PROVIDER_PREFERENCE = 'providerPreferences',
  IDENTITY_PROVIDER_SETTINGS = 'identityProviderSettings',
  IDENTITY_SETTINGS = 'identitySettings',
  MARKUPS = 'markups',
  TICKET_TLO = 'ticketTLO',
  SHOPPING_DIAGNOSTICS = 'shoppingDiagnostics',
  BRANDS = 'brands',
  MARKETS = 'markets',
  DISTRIBUTION_CHANNELS = 'distributionChannels',
  GLOBAL_FILTERS = 'globalFilters',
  GLOBAL_FILTERS_DIAGNOSTICS = 'globalFilterDiagnostics',
  ACTIVITY_LOG = 'activityLog',
  TECHNICAL_LOGS = 'technicalLogs',
  MARKUP_DIAGNOSTICS = 'markupDiagnostics',
  PROVIDERS = 'providers',
  ANCILLARY_SUPPLIER = 'ancillarySuppliers',
  ANCILLARY_DISTRIBUTION = 'ancillaryDistributions',
  VCC_CREDENTIALS = 'vccCredentials',
  BOOKING_CREATE_MANAGER_V2_OSIS = 'bookingCreateManagerV2Osis',
  BOOKING_CREATE_MANAGER_V2_REMARKS = 'bookingCreateManagerV2Remarks',
  BOOKING_CREATE_MANAGER_V2_SSR = 'bookingCreateManagerV2SSR',
  BOOKING_TOLERANCES = 'bookingTolerances',
  ANCILLARY_MANAGER = 'ancillaryManager',
  MARKUPS_V2 = 'markups',
  GLOBAL_FILTERS_V2 = 'globalfiltersv2'
}

export enum PERMISSIONS {
  FULL_CONTROL = 'FullControl',
  DENIED = 'Denied',
  READ_ONLY = 'ReadOnly',
  ALLOWED = 'Allowed',
}

class PermissionsChecker {
  static isPermitted = (category: string, userPermissions: any | null) => {
    if (!userPermissions) return false;
    const permission = userPermissions[category];
    return permission === PERMISSIONS.FULL_CONTROL || permission === PERMISSIONS.READ_ONLY || permission === PERMISSIONS.ALLOWED;
  };

  static isReadOnly = (category?: string, userPermissions?: any | null) => {
    if (!userPermissions || !category) return false;
    const permission = userPermissions[category];
    return permission === PERMISSIONS.READ_ONLY;
  };

  static isFullControl = (category?: string, userPermissions?: any | null) => {
    if (!userPermissions || !category) return false;
    const permission = userPermissions[category];
    return permission === PERMISSIONS.FULL_CONTROL;
  };

  static isAllowed = (category?: string, userPermissions?: any | null) => {
    if (!userPermissions || !category) return false;
    const permission = userPermissions[category];
    return permission === PERMISSIONS.ALLOWED;
  };

  static hasWriteAccess = (category?: string, userPermissions?: any | null) =>
    PermissionsChecker.isFullControl(category, userPermissions) || PermissionsChecker.isAllowed(category, userPermissions);
}

export default PermissionsChecker;
